<template>
  <v-dialog
    v-model="dialogProdInsumosModel"
    persistent
    max-width="900"
    scrollable
    :fullscreen="isMobile()"
  >
    <v-card>
      <v-card-title
        :class="{
          primary: isMobile(),
          'white--text': isMobile(),
          'font-weight-bold': !isMobile(),
        }"
        class="rounded-0"
        >Produtos Disponíveis</v-card-title
      >
      <v-card-title v-if="isMobile()">
        <v-text-field
          v-model="pesquisaModel"
          label="Pesquisar produto"
          append-icon="mdi-magnify"    
          hide-details=""      
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <lista-produtos-disponiveis-insumos />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          :depressed="isMobile()"
          :class="{ secondary: isMobile() }"
          @click="setDialogProdInsumos(false)"
          :text="!isMobile()"
          :block="isMobile()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ListaProdutosDisponiveisInsumos from "../lists/ListaProdutosDisponiveisInsumos.vue";
export default {
  components: { ListaProdutosDisponiveisInsumos },
  computed: {
    ...mapState("insumos", [
      "dialogProdInsumos",
      "produtosDisponiveis",
      "pedido_item",
      "pesquisaProduto",
    ]),
    pesquisaModel: {
      get: function () {
        return this.pesquisaProduto;
      },
      set: function (value) {
        this.setPesquisaProduto(value);
      },
    },
    dialogProdInsumosModel: {
      get: function () {
        return this.dialogProdInsumos;
      },
      set: function (value) {
        this.setDialogProdInsumos(value);
      },
    },
  },
  data: () => ({}),
  methods: {
    ...mapMutations("insumos", ["setDialogProdInsumos", "setPesquisaProduto"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>